import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { DefaultText, openModal, SmallGrayText, SmallText } from '@guryou/html-components';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { dealTokens } from 'components/shared';

const PlayGuideVideoEmbed = ({ videoId, buttonText, modalTitle }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleClick = () => {
    dispatch(openModal('embedModal', { embedUrl: `https://www.youtube.com/embed/${videoId}` }, modalTitle));
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: dealTokens.space[3],
        marginTop: dealTokens.space[6],
        padding: dealTokens.space[3],
        border: `1px solid ${dealTokens.color.border}`,
        borderRadius: dealTokens.radius.md,
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <img
        src={`https://img.youtube.com/vi/${videoId}/0.jpg`}
        alt="Video thumbnail"
        style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: dealTokens.radius.sm, flexShrink: 0 }}
      />
      <div style={{ minWidth: 0, flex: 1 }}>
        <SmallGrayText fontWeight={600}>youtube.com</SmallGrayText>
        <DefaultText fontWeight={700} overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis">
          {modalTitle}
        </DefaultText>
      </div>
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          flexShrink: 0,
          padding: `${dealTokens.space[1]}px ${dealTokens.space[3]}px`,
          borderRadius: dealTokens.radius.pill,
          background: dealTokens.color.text,
          color: dealTokens.color.surface,
        }}
      >
        <PlayArrowIcon style={{ fontSize: '1.1rem' }} />
        <SmallText color={dealTokens.color.surface} fontWeight={800} marginLeft={1}>
          {buttonText || t('GENERAL.watch', 'Guarda')}
        </SmallText>
      </div>
    </div>
  );
};

export default PlayGuideVideoEmbed;
